import { AlertIcon, InfoCircleIcon } from '@approvalmax/ui';
import { Alert, Box, Flex, List, Text, Tooltip } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { SettingsTable } from '../SettingsTable/SettingsTable';
import { messages } from './StepForm.messages';

export const StepForm = memo(() => {
    return (
        <>
            <Flex spacing='4'>
                <Text font='body' fontSize='medium'>
                    {messages.selectOwner}
                </Text>

                <Tooltip activator={<InfoCircleIcon size={16} />} placement='bottom-end'>
                    <Box maxWidth={238}>
                        <Text font='body' fontSize='small'>
                            {messages.selectOwnerTooltip}
                        </Text>
                    </Box>
                </Tooltip>
            </Flex>

            <Text font='body' fontSize='medium'>
                {messages.selectDirector}
            </Text>

            <Alert alignItems='center' color='midnight20' size='small' startIcon={<AlertIcon />}>
                <List listStyle='inside'>
                    <List.Item>{messages.noticeOnlyWalletOwnerCanHaveAccess}</List.Item>

                    <List.Item>{messages.noticeByDefault}</List.Item>

                    <List.Item>{messages.noticeOnlyWalletOwnerCanGrantAccess}</List.Item>
                </List>
            </Alert>

            <SettingsTable />
        </>
    );
});

StepForm.displayName = 'StepForm';
